import { decimal, maxLength, maxValue, required, url } from 'vuelidate/lib/validators'

import { date, requiredForField, requiredWhenExpiryDate, vattenfallUrl } from '@/validators/customValidators'

export const guaranteeModel = {
  form: {
    name: {
      required,
      maxLength: maxLength(128)
    },
    no: {},
    site: {},
    status: {
      required
    },
    obligorName: {
      maxLength: maxLength(128)
    },
    beneficiaryName: {
      maxLength: maxLength(128)
    },
    guarantorName: {
      maxLength: maxLength(128)
    },
    guarantorRating: {
      maxLength: maxLength(128)
    },
    guarantorContractRating: {
      maxLength: maxLength(128)
    },
    startDate: {
      date
    },
    expiryDate: {
      date
    },
    securedAmountCents: {},
    securedAmountPercent: {
      decimal,
      maxValue: maxValue(100)
    },
    physicalStorage: {
      requiredForField: requiredForField('site', 'employer'),
      maxLength: maxLength(256)
    },
    internalContact: {},
    externalContact: {
      maxLength: maxLength(128)
    },
    sentBack: {
      maxLength: maxLength(128)
    },
    returnAddress: {
      maxLength: maxLength(256)
    },
    documentUrl: {
      url,
      vattenfallUrl,
      requiredWhenExpiryDate
    }
  }
}

export const prolongationModel = {
  form: {
    documentUrl: {
      url,
      vattenfallUrl,
      requiredWhenExpiryDate
    },
    expiryDate: {
      date
    }
  }
}
